// extracted by mini-css-extract-plugin
export var titleContainer = "styles-module--title-container---l+eE";
export var metaContainer = "styles-module--metaContainer--qpym8";
export var mainCaption = "styles-module--mainCaption--VyFB-";
export var imageContainer = "styles-module--image-container--Rn+i8";
export var media = "styles-module--media--3rHyW";
export var footerSection = "styles-module--footer-section--3vSDj";
export var shareContainer = "styles-module--share-container--7p8EL";
export var shareButtons = "styles-module--share-buttons--7ZxGX";
export var content = "styles-module--content--G7muo";